import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { ReportRun } from "../../types/reportTypes.ts"

export const getRuns = async (): Promise<ReportRun[]> => {
  const res = await authFetch(`${API_BASE}/reports/runs`)
  const runs: ReportRun[] = await res.json()

  return runs
}
